import SummaryStatistic from "./summary-statistic";

export default SummaryStatistic;